import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/CustomDropdown.css";
import UrltoSlug from "./UrlToSlug";

const AllLocalityDropdown = ({
  subLocalities,
  category,
  commercialServiceQuery = "",
  placeholder = "Select Locality",
  property_type,
}) => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(placeholder);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleSelect = (locality) => {
    setSelected(locality.locality_id);
    const title = {
      buy: "apartments-for-sale-in-",
      rent: "apartments-for-rent-in-",
      plot: "plots-for-sale-in-",
      commercial: "offices-for-sale-in-",
      living: "pg-in-",
    };

    const finalCategory = category === "plot" ? "buy" : category;
    const type =
      category === "commercial"
        ? commercialServiceQuery
        : category === "living"
        ? "living"
        : "";
    const filter = localStorage.setItem(
      "feature_clicked",
      `property_type:${property_type}`
    );

    const text1 = `${finalCategory}/${
      finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
    }searches`;
    const text2 = `${locality?.property_location}-srlid-${locality?.locality_id}`;
    const extra = title[category];
    const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
    navigate(`/${url}`, {
      state: { name: "city", service: category, type: type, filter: filter },
    });
  };

  return (
    <div className="custom-select-container">
      <div
        className={`custom-select2 ${showDropdown ? "active" : ""}`}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        {selected}
      </div>

      {showDropdown && (
        <ul
          className={`locality-custom-dropdown ${showDropdown ? "active" : ""}`}
        >
          {subLocalities.map((locality) => (
            <li
              key={locality.locality_id}
              onClick={() => handleSelect(locality)}
            >
              <span>
                {locality.locality_name}{" "}
                {locality.count > 0 ? `(${locality.count})` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AllLocalityDropdown;
